/** Added to every access token by the Auth0 "Add Email" post-login Action. */
export const auEmailClaim = 'https://platform-ui.goarrowsup.com/email';
